import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "ccpa-wrapper" }
const _hoisted_2 = { class: "opal-dropdown-container" }
const _hoisted_3 = { class: "opal-dropdown-content" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "form-wrapper" }
const _hoisted_7 = { class: "opal-checkboxes-container" }
const _hoisted_8 = ["checked", "onUpdate:modelValue"]
const _hoisted_9 = { class: "opal-button-wrapper" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "error-wrapper" }
const _hoisted_12 = { class: "error" }
const _hoisted_13 = ["href"]

import { ref, computed, onMounted } from "vue";
import { $api } from "@/services/api";
import { useStore } from "vuex";
import { PrivacyNotice } from "@/models/disclosures";
import { EmailAddressConstants } from "@/config/constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'CaliforniaConsumerPrivacyAct',
  setup(__props) {

const store = useStore();

const opalButton = ref(null);
const showCCPA = ref<boolean>(false);
const submissionError = ref<boolean>(false);
const privacyNotices = ref<Array<PrivacyNotice>>([]);
const californiaPrivacyNoticePdfUrl = ref<string>(
  "https://stnonprodcdn.blob.core.windows.net/public/static/privacy-policy/CCPA-Privacy-Notice-10.23.2024.pdf",
);

const toggleIcon = computed(() => (showCCPA.value ? "angle-up" : "angle-down"));
const emailAddress = computed<string>(() => EmailAddressConstants.Privacy);

const ccpaCdnUrl = computed(
  () => store.state.configuration.californiaPrivacyNotice || californiaPrivacyNoticePdfUrl.value,
);

const applicationId = computed(() => store?.state?.appData?.application?.id);
const applicantId = computed(() => store?.state?.appData?.currentApplicant?.id);
const submitting = ref<boolean>(false);

function resetCheckboxes() {
  privacyNotices.value.forEach((p: PrivacyNotice) => (p.isChecked = false));
}

function toggleForm() {
  resetCheckboxes();

  submissionError.value = false;

  showCCPA.value = !showCCPA.value;
}

function resetCCPADropdown() {
  showCCPA.value = false;

  resetCheckboxes();
}

async function submit() {
  submitting.value = true;
  submissionError.value = false;

  const response = await $api.applicant.sendApplicantPrivacyNoticeRequest(
    applicantId.value,
    applicationId.value,
    privacyNotices.value,
  );

  if (response.success) {
    resetCCPADropdown();
  } else {
    submissionError.value = true;
  }

  submitting.value = false;
}

async function getPrivacyNotices() {
  const response = await $api.consents.getPrivacyNoticeDetails(applicationId.value);

  if (response?.success) {
    privacyNotices.value = response.results;
  }
}

onMounted(async () => {
  await getPrivacyNotices();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "opal-dropdown-toggle",
        onClick: toggleForm
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("b", null, "California Consumer Privacy Act (CCPA)", -1)),
        _createVNode(_component_font_awesome_icon, {
          class: "toggle",
          icon: ['fas', toggleIcon.value]
        }, null, 8, ["icon"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _cache[11] || (_cache[11] = _createElementVNode("div", null, [
          _createElementVNode("b", null, "California Residents")
        ], -1)),
        _createElementVNode("p", null, [
          _cache[2] || (_cache[2] = _createTextVNode(" If applicable California law provides additional protections to California residents (as that term is defined under applicable the law). All information collected on such residents, if any, will be in accordance with such laws. ", -1)),
          _createElementVNode("a", {
            target: "_blank",
            href: ccpaCdnUrl.value
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("u", null, "View our California Privacy Notice", -1)
          ]))], 8, _hoisted_4),
          _cache[3] || (_cache[3] = _createTextVNode(" to learn more. California residents may also make a request to know or delete information below if desired. ", -1))
        ]),
        _cache[12] || (_cache[12] = _createElementVNode("div", null, [
          _createElementVNode("b", null, "Notice at Collection")
        ], -1)),
        _cache[13] || (_cache[13] = _createElementVNode("p", null, " Under the California Consumer Privacy Act (“CCPA”), California consumers may be entitled to certain notices and disclosures regarding the collection and use of their Personal Information. This page is intended to provide the Notice at Collection required under the CCPA. ", -1)),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _cache[5] || (_cache[5] = _createTextVNode(" We may collect personal information from you and use it for specified purposes. For a list of categories of personal information that we may collect and the purposes for which we use such persona information, see our ", -1)),
            _createElementVNode("a", {
              target: "_blank",
              href: ccpaCdnUrl.value
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("u", null, "California Privacy Notice", -1),
              _createTextVNode(".", -1)
            ]))], 8, _hoisted_5)
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("li", null, " We do not sell your information for monetary value and do not disclose personal information to third parties in a manner that would be considered a sale of personal information under the CCPA. ", -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(privacyNotices.value, (privacyNotice) => {
              return (_openBlock(), _createElementBlock("label", {
                class: "opal-check checkbox",
                key: privacyNotice.privacyId
              }, [
                _createTextVNode(_toDisplayString(privacyNotice.name), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  checked: privacyNotice.isChecked === true,
                  "onUpdate:modelValue": ($event: any) => ((privacyNotice.isChecked) = $event)
                }, null, 8, _hoisted_8), [
                  [_vModelCheckbox, privacyNotice.isChecked]
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("span", null, null, -1))
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              ref_key: "opalButton",
              ref: opalButton,
              class: "opal-button",
              disabled: submitting.value,
              onClick: submit
            }, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("span", { class: "opal-button-text" }, "Submit", -1)
            ]))], 8, _hoisted_10)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("p", _hoisted_12, [
            _cache[10] || (_cache[10] = _createTextVNode(" We were unable to complete your request. Please submit your request via email to ", -1)),
            _createElementVNode("a", {
              class: "inline-link error",
              href: `mailto:${emailAddress.value}`
            }, [
              _createElementVNode("u", null, _toDisplayString(emailAddress.value), 1),
              _cache[9] || (_cache[9] = _createTextVNode(".", -1))
            ], 8, _hoisted_13)
          ], 512), [
            [_vShow, submissionError.value]
          ])
        ])
      ], 512), [
        [_vShow, showCCPA.value]
      ])
    ])
  ]))
}
}

})